import { noop } from "../utils";
var VideoPlayer = /** @class */ (function () {
    function VideoPlayer(opts) {
        this._freeCallback = [];
        this.video = opts.videoElem;
        this.src = opts.src;
    }
    Object.defineProperty(VideoPlayer.prototype, "videoElem", {
        /**
         * 获取视频元素
         */
        get: function () {
            return this.video;
        },
        enumerable: false,
        configurable: true
    });
    VideoPlayer.prototype._play = function () {
        var _a = this, video = _a.video, src = _a.src;
        video.src = src;
        video.addEventListener("loadedmetadata", function () {
            video.play().catch(noop);
        });
    };
    VideoPlayer.prototype._playByHls = function () {
        var _this = this;
        var _a = this, src = _a.src, video = _a.video;
        var hls;
        import("hls.js").then(function (_a) {
            var Hls = _a.default;
            if (Hls.isSupported()) {
                hls = new Hls();
                hls.loadSource(src);
                hls.attachMedia(video);
                hls.on(Hls.Events.MEDIA_ATTACHED, function () {
                    video.play().catch(noop);
                });
                _this._freeCallback.push(function () {
                    hls.destroy();
                });
            }
        });
    };
    /**
     * 播放视频
     */
    VideoPlayer.prototype.play = function () {
        var _a = this, src = _a.src, video = _a.video;
        if (src.endsWith("mp4")) {
            this._play();
        }
        if (src.endsWith("m3u8")) {
            if (video.canPlayType("application/vnd.apple.mpegurl")) {
                this._play();
            }
            else {
                this._playByHls();
            }
        }
    };
    /**
     * 暂停
     */
    VideoPlayer.prototype.pause = function () {
        this.video.pause();
    };
    /**
     * 释放资源
     */
    VideoPlayer.prototype.destroy = function () {
        this._freeCallback.forEach(function (f) { return f(); });
        this._freeCallback = [];
    };
    return VideoPlayer;
}());
export { VideoPlayer };
